import { GridCellProps } from '@progress/kendo-react-grid';
import { FC } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import { isEqualString } from 'src/utils/strings';

const PoSubjectCreditMemo: FC<GridCellProps> = (props: GridCellProps) => {
  const { displayValue } = useGridCellDisplayValue(props);
  const { dataItem } = props;
  const isJournalEntry = isEqualString(dataItem.action, 'Journal Entry');

  return (
    <GridCellBase {...props} disableToolTip={isJournalEntry}>
      {!isJournalEntry ? <span>{displayValue}</span> : ''}
    </GridCellBase>
  );
};

export default PoSubjectCreditMemo;
